import React from 'react';
import { CONTACT, SUBSCRIBE_URL } from './constants-urls';

export const VALID_USER_WITH_ACTIVE_SUBSCRIPTION = 'VALID_USER_WITH_ACTIVE_SUBSCRIPTION';
export const VALID_USER_WITH_PAPER_ONLY_SUBSCRIPTION = 'VALID_USER_WITH_PAPER_ONLY_SUBSCRIPTION';
export const VALID_USER_WITHOUT_ACTIVE_SUBSCRIPTION = 'VALID_USER_WITHOUT_ACTIVE_SUBSCRIPTION';
export const VALID_USER_WITH_FREE_TRIAL = 'VALID_USER_WITH_FREE_TRIAL';
export const VALID_USER_WITH_EXPIRED_FREE_TRIAL = 'VALID_USER_WITH_EXPIRED_FREE_TRIAL';
export const VALID_USER_WITH_EXPIRED_SUBSCRIPTION = 'VALID_USER_WITH_EXPIRED_SUBSCRIPTION';
export const VALID_USER_WITH_EXPIRED_EGLOBE = 'VALID_USER_WITH_EXPIRED_EGLOBE';
export const VALID_USER_WITH_EXPIRED_GLOBE = 'VALID_USER_WITH_EXPIRED_GLOBE';
export const VALID_USER_WITH_EXPIRED_EGLOBE_AND_GLOBE = 'VALID_USER_WITH_EXPIRED_EGLOBE_AND_GLOBE';

export const INVALID_USER = 'INVALID_USER';
export const FAILED_TO_GENERATE_ARCHIVE_TOKEN = 'FAILED_TO_GENERATE_ARCHIVE_TOKEN';

export const DEFAULT_LOGIN_STATUS_RESPONSE = susbcribe => (
  <p>There was a problem logging you in. <a href={CONTACT}>Contact</a> customer service or <a href={`${SUBSCRIBE_URL}/${susbcribe}/`}>subscribe</a>.</p>);

export const DEFAULT_FORM_ERROR_RESPONSE = () => (
  <p>One or more required fields is missing.</p>);
